import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import { untilDestroyed } from '@app/core';
import { DocumentInput, EmailTemplate, EmailTemplateTypeEnum, User } from '@app/models';
import { AppService, EmailTemplateService, UserService, WhitelabelService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from '@app/shared';
import { Observable } from 'rxjs';
import { delay, finalize, map } from 'rxjs/operators';

@Component({
  selector: 'app-document-configs-email',
  templateUrl: './document-configs-email.component.html',
  styleUrls: ['./document-configs-email.component.scss'],
  standalone: false
})
export class DocumentConfigsEmailComponent implements OnInit, OnDestroy, OnChanges {
  @Input() document: DocumentInput;
  @Input() validationErrors: Record<string, any>;
  @Input() isNewDocument = false;
  @Output() documentChange = new EventEmitter<DocumentInput>();
  currentUser: User;
  emailTemplates: EmailTemplate[];
  emailTemplateSelected: EmailTemplate;
  defaultEmailTemplate: EmailTemplate;
  selectedLang: string;
  firstTime = true;

  constructor(
    public appService: AppService,
    public translateService: TranslateService,
    public whitelabelService: WhitelabelService,
    private userService: UserService // private emailTemplateService: EmailTemplateService
  ) {}

  ngOnInit() {
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.document?.currentValue) {
      this.selectedLang = (this.document.locale?.language || '').replace('-', '');
    }
  }

  updateEmailTemplate() {
    if (this.emailTemplateSelected && this.selectedLang) {
      this.emailTemplateSelected = {
        ...this.emailTemplateSelected,
        [this.selectedLang as 'ptBR' | 'enUS']: {
          ...this.emailTemplateSelected[this.selectedLang as 'ptBR' | 'enUS'],
          text: this.document.message
        }
      };
    }
  }
}
